import { ComponentType } from 'react';
import { BottomNavigationAction } from '@mui/material';

const TAB_MIN_WIDTH_PX = 60; // Supports max 5 tabs. Default MUI value is 80px

export type BottomNavigationTabProps = {
  value: string;
  label: string;
  Icon: ComponentType;
  onClick?(): void;
  routerPath: string;
};

export const BottomNavigationTab = (tab: BottomNavigationTabProps) => (
  <BottomNavigationAction
    key={tab.value}
    value={tab.value}
    label={tab.label}
    onClick={tab.onClick}
    icon={<tab.Icon />}
    sx={{
      minWidth: TAB_MIN_WIDTH_PX,
      '& .MuiBottomNavigationAction-label': {
        whiteSpace: 'nowrap',
      },
    }}
  />
);
